import {
    AfterViewInit,
    Component,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ofType } from '@ngrx/effects';
import { ActionsSubject } from '@ngrx/store';
import moment from 'moment';
import { combineLatest, ReplaySubject } from 'rxjs';
import { filter, startWith, takeWhile, tap } from 'rxjs/operators';
import * as fromDataServices from '../../data-services';
import { LoginModel } from '../../data-services/manage-users/login.model';
import * as fromLookups from '../../lookups';
import { IDirectReport } from '../../lookups';
import { ScheduledDate } from '../../lookups/store/schedule-date.model';
import { Process } from '../../shared';
import {
    Button,
    MenuItem,
    SelectItem,
    Tree,
    UITreeNode
} from '../../shared/efaact-primeng.module';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { ActionTypes } from '../../store/actions';
import * as fromReports from '../store';
import { ReportParams } from '../store/report-params.model';
import { AppComponent } from '../../app.component';
@Component({
    selector: 'ef-reporting',
    templateUrl: './reporting.component.html',
    styleUrls: ['./reporting.component.scss'],
    standalone: false,
    encapsulation: ViewEncapsulation.None // This will help with ::ng-deep issues
})
export class ReportingComponent
    implements OnInit, OnDestroy, AfterViewInit, OnChanges
{
    private _process: Process;
    @Input() public set process(value: Process) {
        this._process = value;
        if (value) {
            this.urlDemo = this._process.UrlDemo;
            this.urlTip = this._process.UrlTip;
            this.UrlDocumentation = this._process.UrlDocumentation;
        }
    }
    public get process(): Process {
        return this._process;
    }
    @Input() reports: UITreeNode[];
    private _contracts: fromDataServices.Contract.Contract[];
    private ContractsSubject = new ReplaySubject<
        fromDataServices.Contract.Contract[]
    >(1);
    @Input() public set contracts(value: fromDataServices.Contract.Contract[]) {
        this._contracts = value;
        this.ContractsSubject.next(value);
    }
    public get contracts(): fromDataServices.Contract.Contract[] {
        return this._contracts;
    }
    public selectedContracts: fromDataServices.Contract.Contract[];
    private _directReports: IDirectReport[];
    private DirectReportsSubject = new ReplaySubject<IDirectReport[]>(1);
    @Input() public set directReports(value: Array<IDirectReport>) {
        this.log.verbose({
            type: 'ReportingComponent:directReports:set',
            value
        });
        this._directReports = value;
        this.DirectReportsSubject.next(value);
    }
    public get directReports(): IDirectReport[] {
        return this._directReports;
    }
    public selectedPeople: LoginModel[];
    @Input() public costCenters: Array<fromLookups.IUserGroup>;
    private ScheduledDatesSubject = new ReplaySubject<Array<ScheduledDate>>(1);
    private _scheduledDates: Array<ScheduledDate>;
    @Input() public set scheduledDates(value: Array<ScheduledDate>) {
        this.log.verbose({
            type: 'ReportingComponent:scheduledDates:set',
            value
        });
        this._scheduledDates = value;
        this.ScheduledDatesSubject.next(value);
    }
    public get scheduledDates(): Array<ScheduledDate> {
        return this._scheduledDates;
    }
    private _selectedScheduledDate: ScheduledDate;
    @Input() public set selectedScheduledDate(value: ScheduledDate) {
        this._selectedScheduledDate = value;
    }
    public get selectedScheduledDate(): ScheduledDate {
        return this._selectedScheduledDate;
    }
    @Input() userEntryStartDate: Date;
    @Input() userEntryEndDate: Date;
    public scheduledDateItems: Array<SelectItem>;
    public directReportItems: Array<LoginModel> = [];
    public contractItems: Array<fromDataServices.Contract.Contract>;
    private _maxReports;
    @Input() public set maxReports(value: number) {
        if (value) {
            this._maxReports = value;
        }
    }
    public get maxReports(): number {
        return this._maxReports;
    }
    @Output() RunReports = new ReplaySubject<{
        reports: Array<fromReports.Report>;
        queryparams: any;
        params: Partial<ReportParams>;
    }>(1);
    @ViewChild('reportTree', { static: true }) reportTree: Tree;
    selectedReports: UITreeNode[];
    reportForm: UntypedFormGroup;
    public msgs: Array<{
        severity: string;
        summary: string;
        detail: string;
    }> = [];

    private active = true;
    public treestyle = {
        'max-height': '87vh',
        height: '87vh',
        overflow: 'hidden',
        width: '100%',
    };
    public clearOptions: MenuItem[] = [
        {
            label: 'Filters',
            title: 'Clear Filters',
            command: () => {
                this.clearFilters();
            }
        },
        {
            label: 'Reports',
            title: 'Clear Reports',
            command: () => {
                this.clearReports();
            }
        }
    ];
    urlDemo: string;
    urlTip: string;
    UrlDocumentation: string;

    treeFilterContainer: any;
    filterResetBtn: any;

    @Output() FavoriteToggle = new ReplaySubject<{
        RptID: string;
        EmployeeListID: string;
        IsFavorite: boolean;
    }>(1);

    constructor(
        private log: LoggingService,
        private dispatcher: ActionsSubject,
        public app: AppComponent
    ) {
        this.reportForm = new UntypedFormGroup({
            useScheduledDates: new UntypedFormControl(false),
            reportDates: new UntypedFormControl(),
            contracts: new UntypedFormControl(),
            directReports: new UntypedFormControl(),
            scheduledDates: new UntypedFormControl(),
            showAllContracts: new UntypedFormControl(false),
            showAllPeople: new UntypedFormControl(false),
            selectedPeople: new UntypedFormControl([]),
            selectedContracts: new UntypedFormControl([]),
        });
    }
    ngOnInit() {
        this.setupSubscriptions();
    }

    ngOnDestroy() {
        this.active = false;
    }
    ngAfterViewInit() {
        this.log.verbose({
            type: 'ReportingComponent:ngAfterViewInit',
            selectedScheduledDate: this.selectedScheduledDate
        });
    }
    ngOnChanges(changes: SimpleChanges) {
        this.log.verbose({
            type: 'ReportingComponent:ngOnChanges',
            changes
        });

        var controls = this.reportForm.controls;
        if (
            changes &&
            changes.userEntryStartDate &&
            changes.userEntryStartDate.currentValue &&
            changes.userEntryEndDate &&
            changes.userEntryEndDate.currentValue
        ) {
            controls['reportDates'].setValue([
                changes.userEntryStartDate.currentValue,
                changes.userEntryEndDate.currentValue
            ]);
        }
    }
    setupSubscriptions() {
        this.dispatcher
            .pipe(
                ofType(
                    ActionTypes.Reset,
                    ActionTypes.Logout,
                    ActionTypes.Login
                ),
                takeWhile(() => this.active)
            )
            .subscribe(resp => {
                this.log.verbose({
                    type: 'ReportingComponent:Logout'
                });
                this.selectedReports = [];
                this.reportForm.reset();
                this.reportForm.controls['useScheduledDates'].setValue(false);
            });

        this.ScheduledDatesSubject.pipe(
            takeWhile(() => this.active),
            filter(dates => !!dates)
        ).subscribe(dates => {
            this.log.verbose({
                type: 'ReportingComponent:ScheduledDatesSubject',
                dates
            });
            this.scheduledDateItems = dates.map(d => ({
                label: `${moment(d.ScheduledStartDate).format(
                    'MM/DD/YY'
                )} - ${moment(d.ScheduledEndDate).format('MM/DD/YY')} ${
                    d.ScheduledDatePurpose
                }`,
                value: d.ScheduledDateID
            }));
            const selected = dates.find(d1 =>
                moment(d1.ScheduledEndDate).isSameOrAfter()
            );
            this.log.verbose({
                type: 'ReportingComponent:ScheduledDatesSubject',
                selected
            });

            if (!!selected) {
                setTimeout(() => {
                    this.reportForm.controls['scheduledDates'].setValue(
                        selected.ScheduledDateID
                    );
                }, 0);
            }
        });

        combineLatest([
            this.DirectReportsSubject.pipe(filter(x => !!x && x.length > 0)),
            this.reportForm.controls['showAllPeople'].valueChanges.pipe(
                startWith(false)
            )
        ])
            .pipe(
                takeWhile(() => this.active),
                tap(([reports, showAll]) =>
                    this.log.verbose({
                        type: 'ReportingComponent:combineLatest(DirectReportsSubject, showAllPeople)',
                        reports,
                        showAll
                    })
                )
            )
            .subscribe(([reports, showall]) => {
                this.directReportItems = reports
                    .filter(dr => (showall ? showall : dr.IsActive))
                    .map(dr => ({
                        ...dr,
                        id: dr.EmployeeListID,
                        SupervisorName: reports.find(
                            x => x.EmployeeListID === dr.SupervisorListID
                        )
                            ? reports.find(
                                  x => x.EmployeeListID === dr.SupervisorListID
                              ).EmployeeName
                            : '',
                        CostCenterName: this.costCenters.find(
                            x => x.GroupID === dr.CostCenterID
                        )
                            ? this.costCenters.find(
                                  x => x.GroupID === dr.CostCenterID
                              ).GroupName
                            : '',
                        Status: null,
                        Row_Version: null
                    }));
            });
        combineLatest([
            this.ContractsSubject,
            this.reportForm.controls['showAllContracts'].valueChanges.pipe(
                startWith(false)
            )
        ])
            .pipe(takeWhile(() => this.active))
            .subscribe(([contracts, showall]) => {
                this.contractItems = contracts.filter(c =>
                    showall ? showall : c.IsActive
                );
            });
    }
    onNodeSelect($event) {
        this.log.verbose({
            type: 'ReportingComponent:onNodeSelect',
            $event,
            reportTree: this.reportTree
        });
    }
    onSelectionChange($event: Array<UITreeNode>) {
        const reports = $event.filter(x => x.rowNode.RptID);
        this.log.verbose({
            type: 'ReportingComponent:onSelectionChange',
            $event,
            reports
        });
        if (reports.length > this.maxReports) {
            this.msgs = [
                {
                    severity: 'warn',
                    summary: 'Max Reports Exceeded',
                    detail: `You have selected more than the maximum number of simultaneous reports.  Only the first ${this.maxReports} will be run.`
                }
            ];
            this.treestyle = {
                'max-height': '87vh',
                height: '87vh',
                overflow: 'hidden',
                width: '100%',
            };
        } else {
            this.msgs = [];
            this.treestyle = {
                'max-height': '87vh',
                height: '87vh',
                overflow: 'hidden',
                width: '100%',
            };
        }
    }
    runReports($event: UITreeNode[]) {
        const formValue = this.reportForm.value;
        const selectedPeople = formValue.selectedPeople || [];
        const selectedContracts = formValue.selectedContracts || [];
        const reports = $event.filter(x => x.rowNode.RptID);
        const controls = this.reportForm.controls;
        this.log.verbose({
            type: 'ReportingComponent:runReports',
            reports,
            form: this.reportForm,
            selectedPeople: this.selectedPeople,
            selectedContracts: this.selectedContracts,
            dates: controls['reportDates'].value,
            scheduledDates: controls['scheduledDates'].value,
            useScheduledDates: controls['useScheduledDates'].value
        });
        let reportDates: Date[] = [new Date(), new Date()];
        if (controls['useScheduledDates'].value) {
            const scheduledDate = this.scheduledDates.find(
                x => x.ScheduledDateID === controls['scheduledDates'].value
            );
            if (scheduledDate) {
                reportDates[0] = scheduledDate.ScheduledStartDate;
                reportDates[1] = scheduledDate.ScheduledEndDate;
            }
        } else {
            reportDates = controls['reportDates'].value || reportDates;
        }
        const directReports = controls['directReports'].value as string[];
        const contractList = controls['contracts'].value as string[];
        const data = {
            reports: reports.map(x => x.rowNode),
            queryparams: {
                StartDate: moment(reportDates[0]).isValid()
                    ? moment(reportDates[0]).format('YYYY-MM-DD')
                    : null,
                EndDate: moment(reportDates[1]).isValid()
                    ? moment(reportDates[1]).format('YYYY-MM-DD')
                    : moment(reportDates[0]).isValid()
                    ? moment(reportDates[0]).format('YYYY-MM-DD')
                    : null
            },
            params: {
                DirectReportList: selectedPeople
                    ? selectedPeople.map(x => ({
                          id: x.EmployeeListID,
                          EmployeeListID: x.EmployeeListID,
                          EmployeeName: x.EmployeeName,
                          Status: null,
                          Row_Version: null
                      }))
                    : [],
                ContractList: selectedContracts
            }
        };
        // TODO: check if API wants this to be null or non-existent
        if (!data.queryparams.StartDate) {
            delete data.queryparams.StartDate;
        }
        this.RunReports.next(data);
    }
    onClear() {
        this.log.verbose({
            type: 'ReportingComponent:onClear'
        });
        this.clearFilters();
        this.clearReports();
    }
    clearReportFilter() {
        this.reportTree.resetFilter();
    }
    clearFilters() {
        this.log.verbose({
            type: 'ReportingComponent:clearFilters'
        });
        this.reportForm.reset({
            useScheduledDates: false,
            showAllContracts: false,
            showAllPeople: false
        });
        this.selectedPeople = [];
        this.selectedContracts = [];
        this.selectedScheduledDate = null;
        this.ScheduledDatesSubject.next(this.scheduledDates);
    }
    clearReports() {
        this.log.verbose({
            type: 'ReportingComponent:clearReports'
        });
        this.reportTree.resetFilter();
        this.selectedReports = [];
        this.reportForm.reset();
        //// this.reportForm.controls['useScheduledDates'].setValue(true);
        //this.selectedPeople = [];
        //this.selectedContracts = [];
        this.onSelectionChange([]);
        this.reportForm.controls['reportDates'].setValue([
            this.userEntryStartDate,
            this.userEntryEndDate
        ]);
        this.ScheduledDatesSubject.next(this._scheduledDates);
    }

    isFavorite(node: any): boolean {
        return node.data?.isFavorite || false;
    }
    toggleFavorite(node: any, event: Event): void {
        event.stopPropagation();

        if (!node.data) {
            node.data = {};
        }
        node.data.isFavorite = !node.data.isFavorite;

        this.FavoriteToggle.next({
            RptID: node.rowNode?.RptID || node.data?.RptID,
            EmployeeListID: node.rowNode?.EmployeeListID || node.data?.EmployeeListID,
            IsFavorite: node.data.isFavorite
        });
    }
}
